import React, { Component } from 'react';
import Draggable from 'react-draggable';
// https://github.com/mzabriskie/react-draggable

class Logopart extends Component {
    startShake(e) {
        document.getElementById(this.props.id).className = 'shaking';
    }

    stopShake(e) {
        document.getElementById(this.props.id).className = "";
    }

    render() {
        const style = {
            width: this.props.w,
            left: this.props.x,
            top: this.props.y
        }
        return (
            <Draggable
        axis="both"
        handle=".handle"
        disabled={false}
        defaultPosition={{x:0, y:0}}
        position={null}
        grid={[1, 1]}
        zIndex={2000} >
          <div className="logo-part" style={style} onMouseOver={this.startShake.bind(this)} onMouseLeave={this.stopShake.bind(this)} >
            <div className="handle">
              <div id={this.props.id}>
                {this.props.svg}
              </div>
            </div>
          </div>
      </Draggable>
        );
    }
}

export default Logopart;



// WEBPACK FOOTER //
// ./src/components/Landing/Logopart.js